export default "__VITE_ASSET__WugY_05l__"